// extracted by mini-css-extract-plugin
export var card = "CardScroll-module--card--47089";
export var cardClickable = "CardScroll-module--cardClickable--032cb CardScroll-module--card--47089";
export var cardHighlight = "CardScroll-module--cardHighlight--4b4af";